import { useForm } from '@mantine/form';

import {
  selectCurrencies,
  useAppSelector,
  useGetCurrenciesQuery,
  useShowResponseStatus,
} from '@/shared';
import { useCreateCurrencyMutation } from '../store/config-api';
import { handleConfigCurrencyCreateError } from '../utils/helpers/config-errors';

import type { TCreateCurrencyParams } from '../store/types';

const currencyCodePattern = /^[A-Z]{3,12}$/;

export const useConfigCurrencies = () => {
  const currencies = useAppSelector(selectCurrencies);
  const { isFetching: isCurrenciesFetching, isError: isCurrenciesError } = useGetCurrenciesQuery();
  const [createCurrency, {
    isLoading: isCreateLoading,
    isSuccess,
    isError: isCreateError,
    error,
  }] = useCreateCurrencyMutation();
  const createError = handleConfigCurrencyCreateError(error);

  const form = useForm<TCreateCurrencyParams>({
    mode: 'controlled',
    initialValues: {
      code: '',
    },
    validate: {
      code: (value) => currencyCodePattern.test(value)
        ? null
        : 'Введите от 3 до 12 заглавных латинских букв',
    },
  });

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Валюта успешно добавлена',
    isError: isCurrenciesError || (isCreateError && !createError),
    error: createError,
  });

  const handleSubmit = async (values: TCreateCurrencyParams) => {
    const result = await createCurrency(values);
    if ('error' in result) {
      return;
    }

    form.reset();
  };

  return {
    currencies,
    form,
    isLoading: isCurrenciesFetching || isCreateLoading,
    handleSubmit,
  };
};
